var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeonInmobiliariaIconsTv = function SvgLeonInmobiliariaIconsTv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".leon-inmobiliaria-icons-tv_svg__st0{display:none}.leon-inmobiliaria-icons-tv_svg__st1{fill:currentcolor}.leon-inmobiliaria-icons-tv_svg__st1,.leon-inmobiliaria-icons-tv_svg__st2{display:inline}.leon-inmobiliaria-icons-tv_svg__st3{fill:currentcolor}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leon-inmobiliaria-icons-tv_svg__TV"
  }, /*#__PURE__*/React.createElement("path", {
    id: "leon-inmobiliaria-icons-tv_svg__Pfad_5123",
    className: "leon-inmobiliaria-icons-tv_svg__st3",
    d: "M16.5 21.7h68v41.1h-68V21.7zm-5.6-5.5v52.2h36.4v7.5H35.8c-1.5 0-2.8 1.2-2.8 2.8 0 1.5 1.2 2.8 2.8 2.8h28.8c1.5 0 2.8-1.2 2.8-2.8 0-1.5-1.2-2.8-2.8-2.8H52.9v-7.5H90V16.2H10.9z"
  }))));
};
export default SvgLeonInmobiliariaIconsTv;